import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { type } from 'os'
import { InvoiceDiscountForm, InvoiceRowForm } from '../../core/_models'
import { InvoiceDiscountEditModalHeader } from './InvoiceDiscountEditModalHeader'
import { InvoiceDiscountEditModalForm } from './InvoiceDiscountEditModalForm'

type props = {
  discountItem: {
    discountItem: InvoiceDiscountForm | null | undefined,
    setDiscountItem: React.Dispatch<React.SetStateAction<InvoiceDiscountForm | null | undefined>>
  }
  discounts: {
    discounts: InvoiceDiscountForm[],
    setDiscounts: Dispatch<SetStateAction<InvoiceDiscountForm[]>>
  }
  sumAdPrice: number
}

const InvoiceDiscountEditModal: FC<props> = ({ discountItem, discounts, sumAdPrice }) => {
  const [title, setTitle] = useState<string>('افزودن تخفیف به صورتحساب')

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_invoice'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-xl modal-fullscreen-sm-down mp-invoice-subdialog'>
          {/* begin::Modal content */}
          <div className='modal-content'
            style={{ minHeight: '75vh' }}>
            <InvoiceDiscountEditModalHeader title={title} discountItem={discountItem} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y'>
              <InvoiceDiscountEditModalForm discountItem={discountItem} discounts={discounts} sumAdPrice={sumAdPrice} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export { InvoiceDiscountEditModal }
